<template>
    <div class="basicData" v-wechat-title="$t('诊断功能维护')">
        <Title :title="$t('诊断功能维护')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('功能名称') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.name" clearable></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('报文号') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.messageCode" clearable></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('功能类型') }}</span></div>
                    <div class="input_box">
                        <el-select v-model.trim="parameters.parameters.functionType" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in functionType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('文件类型') }}</span></div>
                    <div class="input_box">
                        <el-select v-model.trim="parameters.parameters.fileType" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in fileType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('大组') }}</span></div>
                    <div class="input_box">
                        <el-select v-model.trim="parameters.parameters.parentGroupId" @change="changeParentGroup" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in parentGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('小组') }}</span></div>
                    <div class="input_box">
                        <el-select v-model.trim="parameters.parameters.functionGroupId" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="search_btn" @click="search">{{ $t('查询') }}</button>
            <button type="button" class="download_btn" @click="downloadExcel">{{ $t('下载模板') }}</button>
            <button type="button" class="import_btn" @click="importExcel" v-permissions="26030706">{{ $t('导入') }}</button>
            <button type="button" class="delete_btn" @click="deleteList" v-permissions="26030705">{{ $t('删除') }}</button>
            <button type="button" class="add_btn" @click="openNewDialog" v-permissions="26030703">{{ $t('新建') }}</button>
        </div>
        <div class="table_box">
            <el-table :data="list" v-loading="loading" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column :label="$t('功能名称')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.name || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('报文号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.messageCode || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('功能类型')" align="center">
                    <template slot-scope="scope">
                        {{ changeFunctionType(scope.row.functionType) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('文件类型')" align="center">
                    <template slot-scope="scope">
                        {{ changeFileType(scope.row.fileType) }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('文件目录')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.url">{{ scope.row.url || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('控制属性')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.attribute">{{ scope.row.attribute || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('大组')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.parentGroupName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('小组')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.groupName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center" width="200">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <span class="table_btn edit" :title="$t('编辑')" @click.stop="edit(scope.row)"></span>
                            <span class="table_btn delete" :title="$t('删除')" @click.stop="deleteItem(scope.row)" v-permissions="26030704"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_box">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="10"
                    :current-page="parameters.page"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageInfo.total">
            </el-pagination>
        </div>
        <el-dialog :visible="visible" center :title="$t('新建/编辑诊断功能')" :show-close="false" width="550px">
            <el-form ref="form" :model="addParameters" label-width="119px">
                <el-form-item :label="$t('功能名称')">
                    <div style="width: 340px;">
                        <el-input  v-model.trim="addParameters.name" clearable maxlength="15"></el-input>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('功能类型')">
                    <div style="width: 340px;">
                        <el-select style="width: 340px;" v-model.trim="addParameters.functionType" :placeholder="$t('请选择')" @change="changeFunctionTypeSelect" clearable>
                            <el-option v-for="item in functionType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('报文号')">
                    <div style="width: 340px;">
                        <el-input v-model="addParameters.messageCode" disabled></el-input>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('文件类型')">
                    <div style="width: 340px;">
                        <el-select style="width: 340px;" v-model.trim="addParameters.fileType" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in fileType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('文件目录')">
                    <div style="width: 340px;">
                        <el-input :placeholder="placeholderText1" v-model="addParameters.url" :disabled="addParameters.functionType === 104 || addParameters.functionType === 106" maxlength="2000"></el-input>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('控制属性')" v-if="addParameters.functionType === 104">
                    <div style="width: 340px;">
                        <el-input :placeholder="placeholderText2" v-model="addParameters.attribute" disabled></el-input>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('脚本上传')" v-if="addParameters.functionType === 104">
                    <div style="width: 340px;">
                        <el-dialog center top="30vh" width="40%" :title="$t('脚本上传')" :visible="innerVisible" append-to-body :show-close="false">
                            <el-form label-width="119px">
                                <el-form-item :label="$t('脚本上传')">
                                    <div style="width: 340px;">
                                        <el-upload :action="uploadUrl" multiple :limit="1" :file-list="uploadSuccessRes.fileList" :on-success="uploadSuccess" :on-remove="removeFile">
                                            <el-button size="small" type="primary">{{ $t('上传') }}</el-button>
                                        </el-upload>
                                    </div>
                                </el-form-item>
                            </el-form>
                            <span slot="footer" class="dialog_footer">
                                <button type="button" class="back_btn" @click="cancelUploadBtn">{{ $t('取消') }}</button>
                                <button type="button" class="save_btn" @click="saveUpload">{{ $t('确定') }}</button>
                            </span>
                        </el-dialog>
                        <button type="button" class="save_btn" @click.stop="innerVisible = true">{{ addParameters.url ? $t('更改上传') : $t('上传') }}</button>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('是否传参')" v-if="addParameters.functionType === 104">
                    <div style="width: 340px;">
                        <el-radio-group v-model="addParameters.hasParam">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('大组')">
                    <div style="width: 340px;">
                        <el-select style="width: 340px;" v-model.trim="addParameters.parentGroupId" @change="changeParentGroup" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in parentGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('小组')">
                    <div style="width: 340px;">
                        <el-select style="width: 340px;" v-model.trim="addParameters.functionGroupId" :placeholder="$t('请选择')" clearable>
                            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog_footer">
                <button type="button" class="back_btn" @click="cancelBtn">{{ $t('取消') }}</button>
                <button type="button" class="save_btn" @click="add" v-permissions="26030703">{{ $t('确定') }}</button>
            </span>
        </el-dialog>
        <input id="file" @change="changeFile($event)" v-show="false" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel " multiple="multiple">
    </div>
</template>

<script>
    import { DOMAIN } from "../../plugins/domain";
    export default {
        data () {
            return {
                placeholderText1: '',
                placeholderText2: '',
                addParameters: {
                    id: '',
                    name: '',
                    functionType: '',
                    messageCode: '',
                    fileType: '',
                    url: '',
                    attribute: '',
                    parentGroupId: '',
                    functionGroupId: '',
                    hasParam: 0
                },
                visible: false,
                innerVisible: false,
                loading: false,
                list: [],
                pageInfo: {
                    total: 0
                },
                parameters: {
                    page: 1,
                    rows: 10,
                    parameters: {
                        name: '',
                        messageCode: '',
                        functionType: '',
                        fileType: '',
                        parentGroupId: '',
                        functionGroupId: ''
                    }
                },
                deleteListId: [],
                uploadUrl: DOMAIN.fileFTP + '/file/getMd5ByFile',
                uploadFile: {
                    file: '',
                    type: 3
                },
                functionType: [],
                fileType: [],
                parentGroupList: [],
                groupList: [],
                saveUploadParameters: {
                    file: '',
                    md5: '',
                    releaseDate: '',
                    changelog: '',
                    versionName: '',
                    appId: 'remote-diagnosis',
                    appCode: 'remote-diagnosis',
                    appType: 'remote-diagnosis15',
                    channel: 1
                },
                uploadSuccessRes: {
                    fileList: []
                }
            }
        },
        mounted () {
            this.initMounted()
        },
        methods: {
            initMounted () {
                this.placeholderText1 = this.$t('路径');
                this.functionType = [
                    {id: 101, name: this.$t('文件内容')},
                    {id: 102, name: this.$t('下载文件')},
                    {id: 103, name: this.$t('文件列表')},
                    {id: 104, name: this.$t('执行脚本')},
                    {id: 105, name: this.$t('指定参数')},
                    {id: 106, name: this.$t('参数池文件')}
                ]
                this.fileType = [
                    {id: 1, name: this.$t('参数')},
                    {id: 2, name: this.$t('程序')},
                    {id: 3, name: this.$t('配置')},
                    {id: 4, name: this.$t('目录')},
                    {id: 5, name: this.$t('图片')},
                    {id: 6, name: this.$t('日志')}
                ]
                this.getList()
                this.getFunctionGroupList()
            },
            changeFile (el) {
                this.uploadFile.file = el.target.files[0]
                this.$loading({
                    lock: true,
                    text: this.$t('正在导入') + '...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch('a:common/importExcelFunction', this.uploadFile).then(
                    res => {
                        this.$loading().close()
                        res.success ? this.$message.success(this.$t('保存成功')) : this.$message({type: 'error', dangerouslyUseHTMLString: true, message: res.errMsg});
                        this.getList()
                    },
                    rej => {
                        this.$loading().close()
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            downloadExcel () {
                this.$store.dispatch('a:common/readGlobalParam', {paramName: 'importModelRemoteFunction'}).then(
                    res => {
                        window.open(res)
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            importExcel () {
                document.getElementById('file').value = '';
                document.getElementById('file').click()
            },
            openNewDialog () {
                this.resetDialogData()
                this.visible = true;
            },
            cancelUploadBtn () {
                this.uploadSuccessRes.fileList = [];
                this.innerVisible = false;
            },
            cancelBtn () {
                this.resetDialogData()
                this.visible = false
            },
            uploadSuccess (res, file) {
                this.uploadSuccessRes = {
                    ...res,
                    fileList: [file.raw]
                };
            },
            removeFile () {
                this.uploadSuccessRes.fileList = [];
            },
            saveUpload () {
                if (this.uploadSuccessRes.fileList.length === 0) {
                    this.$message.info(this.$t('请先上传文件'));
                    return false
                }
                this.saveUploadParameters.file = this.uploadSuccessRes.fileList[0];
                this.saveUploadParameters.md5 = this.uploadSuccessRes.md5;
                this.saveUploadParameters.releaseDate = this.uploadSuccessRes.releaseDate;
                this.saveUploadParameters.changelog = this.uploadSuccessRes.changeLog;
                this.saveUploadParameters.versionName = this.uploadSuccessRes.fileName;
                this.$loading({
                    lock: true,
                    text: this.$t('正在上传...'),
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch('a:common/uploadOther', this.saveUploadParameters).then(
                    res => {
                        this.$loading().close();
                        this.addParameters.attribute = res.md5;
                        this.addParameters.url = res.downloadUrl;
                        this.uploadSuccessRes.fileList = [];
                        this.innerVisible = false;
                    },
                    rej => {
                        this.$loading().close();
                        this.uploadSuccessRes.fileList = [];
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            search () {
                this.parameters.page = 1
                this.getList()
            },
            edit (item) {
                this.getFunctionGroupListRead(item.parentGroupId, true, item.groupId)
                this.addParameters = {
                    ...item,
                    functionGroupId: item.groupId
                }
                this.visible = true
            },
            resetDialogData () {
                this.addParameters = {
                    id: '',
                    name: '',
                    functionType: '',
                    messageCode: '',
                    fileType: '',
                    url: '',
                    attribute: '',
                    parentGroupId: '',
                    functionGroupId: '',
                    hasParam: 0
                };
                this.saveUploadParameters = {
                    file: '',
                    md5: '',
                    releaseDate: '',
                    changelog: '',
                    versionName: '',
                    appId: 'remote-diagnosis',
                    appCode: 'remote-diagnosis',
                    appType: 'remote-diagnosis15',
                    channel: 1
                };
                this.parameters.parameters = {
                    name: '',
                    messageCode: '',
                    functionType: '',
                    fileType: '',
                    parentGroupId: '',
                    functionGroupId: ''
                };
                this.groupList = [];
            },
            handleSelectionChange (value) {
                let idList = []
                for (let item of value) {
                    idList.push(item.id)
                }
                this.deleteListId = idList
            },
            add () {
                if (!this.addParameters.name || !this.addParameters.fileType || !this.addParameters.url || !this.addParameters.parentGroupId || !this.addParameters.functionGroupId) {
                    this.$message.info(this.$t('请完善诊断功能信息！'));
                    return false
                }
                if (this.addParameters.functionType === 104 && !this.addParameters.attribute) {
                    this.$message.info(this.$t('请完善诊断功能信息！'));
                    return false
                }
                this.$store.dispatch('a:maintainDiagnose/save', this.addParameters).then(
                    res => {
                        this.$message.success(this.$t('保存成功'));
                        this.visible = false;
                        this.addParameters = {
                            id: '',
                            name: '',
                            functionType: '',
                            messageCode: '',
                            fileType: '',
                            url: '',
                            attribute: '',
                            parentGroupId: '',
                            functionGroupId: '',
                            hasParam: 0
                        };
                        this.getList()
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            deleteItem (item) {
                this.$confirm(this.$t('删除后无法恢复，确认删除该条记录'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(() => {
                    this.$store.dispatch('a:maintainDiagnose/delete', {id: item.id}).then(
                        res => {
                            this.$message.success(this.$t('成功删除'))
                            if (this.pageInfo.isLastPage && this.list.length === 1 && this.parameters.page > 1) {
                                this.parameters.page--
                            }
                            this.getList()
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {

                });
            },
            deleteList () {
                if (this.deleteListId.length === 0) {
                    this.$message.info(this.$t('请先选择后再删除'));
                    return false
                }
                this.$confirm(this.$t('删除后无法恢复，确认删除选择的记录吗'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(() => {
                    this.$store.dispatch('a:maintainDiagnose/deleteMultiple', {ids: this.deleteListId.join(), deleteAll: false}).then(
                        res => {
                            this.$message.success(`${ this.$t('成功删除') } ${ this.deleteListId.length } ${ this.$t('条数据') }`)
                            this.getList()
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {

                });
            },
            changeFunctionTypeSelect (val) {
                this.addParameters.messageCode = this.addParameters.functionType;
                this.addParameters.fileType = this.addParameters.url = this.addParameters.attribute = '';
                this.addParameters.hasParam = 0;
                switch (val) {
                    case 101:
                        this.placeholderText1 = this.$t('路径1|路径2|…');
                        break;
                    case 102:
                        this.placeholderText1 = this.$t('路径');
                        break;
                    case 103:
                        this.placeholderText1 = this.$t('路径');
                        break;
                    case 104:
                        this.placeholderText1 = this.$t('上传文件获取目录');
                        this.placeholderText2 = this.$t('上传文件获取属性');
                        break;
                    case 105:
                        this.placeholderText1 = this.$t('参数名1|参数名2|…');
                        break;
                    case 106:
                        this.addParameters.url = 'param.txt';
                        break;
                    default:
                        this.placeholderText1 = this.$t('路径');
                }
            },
            changeParentGroup (val) {
                this.parameters.parameters.functionGroupId = '';
                this.addParameters.functionGroupId = '';
                this.groupList = [];
                if (val) this.getFunctionGroupListRead(val)
            },
            handleSizeChange (val) {
                this.parameters.rows = val;
                this.getList()
            },
            handleCurrentChange (val) {
                this.parameters.page = val;
                this.getList()
            },
            getList () {
                this.loading = true
                this.$store.dispatch('a:maintainDiagnose/getList', this.parameters).then(
                    res => {
                        this.list = res.list || [];
                        this.pageInfo = res.pageInfo;
                        this.loading = false
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                        this.loading = false
                    }
                )
            },
            getFunctionGroupList () {
                this.$store.dispatch('a:maintainDiagnose/getFunctionGroupList', {page: 1, rows: 1000, parameters: {}}).then(
                    res => {
                        this.parentGroupList = res.list
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getFunctionGroupListRead (id, isEdit, selectId) {
                this.$store.dispatch('a:maintainDiagnose/getFunctionGroupListRead', {id: id}).then(
                    res => {
                        this.groupList = res.list;
                        if (isEdit) this.addParameters.functionGroupId = selectId
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
